import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { useUserInfo } from '@repository/auth/useUserInfo';
import Colors from '@domain/constant/colors';
import { gradeTextSelectMap } from '@domain/constant/gradeType';
import { AccaProfileType } from '@domain/constant/AccaProfileType';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './userInfo.module.scss';
import { usePhsCenterResultType } from '@repository/phs/center/usePhsCenter';
const cx = classnames.bind(styles);

const UserInfo = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { data: resultData } = usePhsCenterResultType(isLogin);

  const isProfileImage = !!resultData?.profileImageUrl;
  const paccResult = !!resultData?.paccResult; // 개역검 결과
  const pstResult = !!resultData?.pstResult; // 개능검 결과
  const badgeText = !resultData?.paccResult ? '나의 역량 유형은?' : AccaProfileType[resultData?.paccResult].name;
  const grade = resultData?.pstResult; // 최고등급

  const userInfoComponent = (paccResult: boolean, pstResult: boolean) => {
    // [D] 로그인 안 한 경우 & 분석완료 역검이 없는 경우(개역검X && 개능검X)
    if (!isLogin || (!paccResult && !pstResult))
      return (
        <div className={cx('userInfoInner', 'default')}>
          <div className={cx('userInfoWrap')} />

          <div className={cx('textArea')}>
            “개발자 검사 응시하고,
            <br />
            역량유형, 개발능력 확인하세요.”
          </div>
        </div>
      );

    // [D] 개역검O && 개능검O
    if (paccResult && pstResult)
      return (
        <div className={cx('userInfoInner')}>
          <div className={cx('userInfoWrap')}>
            {/* [D] 유저 이미지 없는 경우 'default' 클래스 추가 */}
            <div
              className={cx('profileImage', { default: !isProfileImage })}
              style={isProfileImage ? { backgroundImage: `url(${resultData?.profileImageUrl})` } : {}}
            >
              {/* [D] 유저 이미지 없는 경우 default 이미지 추가 */}
              {!isProfileImage && <Icon name="profileDefault" width={72} height={72} />}
              {/* [D] 개능검 미응시인 경우 'default' 클래스 추가 */}
              {/* [D] grade 값으로 아이콘 분기 처리 */}
              {grade && (
                <div className={cx('gradeArea', { default: !pstResult }, grade)}>
                  <div className={cx('tooltipArea')}>
                    <div className={cx('tooltip')}>최고등급 : {gradeTextSelectMap[grade]}</div>
                    <Icon name="tooltipBottomTail" width={8} height={8} fill={Colors.C_COOL_GRAY_70} />
                  </div>
                </div>
              )}
            </div>
            {/* [D] 개역검 미응시인 경우 'default' 클래스 추가 및 '나의 역량 유형은?' 텍스트 변경 */}
            <span className={cx('badge', { default: !paccResult })}>{badgeText}</span>
            <span className={cx('name')}>{resultData?.name}님</span>
          </div>
          <div className={cx('textArea')}>
            “개발자 검사를 활용해서
            <br />
            취업에 성공하세요.”
          </div>
        </div>
      );

    // [D] 개역검O && 개능검X
    if (paccResult && !pstResult)
      return (
        <Link href={RouteUrl.PHS_PST_TEST_GATE} legacyBehavior>
          <a className={cx('userInfoInner')} target="_blank" role="button">
            <div className={cx('userInfoWrap')}>
              {/* [D] 유저 이미지 없는 경우 'default' 클래스 추가 */}
              <div
                className={cx('profileImage', { default: !isProfileImage })}
                style={isProfileImage ? { backgroundImage: `url(${resultData?.profileImageUrl})` } : {}}
              >
                {/* [D] 유저 이미지 없는 경우 default 이미지 추가 */}
                {!isProfileImage && <Icon name="profileDefault" width={72} height={72} />}
                {/* [D] 개능검 미응시인 경우 'default' 클래스 추가 */}
                <div className={cx('gradeArea', { default: !pstResult })}>
                  ?
                  <div className={cx('tooltipArea')}>
                    <div className={cx('tooltip')}>최고등급 : -</div>
                    <Icon name="tooltipBottomTail" width={8} height={8} fill={Colors.C_COOL_GRAY_70} />
                  </div>
                </div>
              </div>
              {/* [D] 개역검 미응시인 경우 'default' 클래스 추가 및 '나의 역량 유형은?' 텍스트 변경 */}
              <span className={cx('badge', { default: !paccResult })}>{badgeText}</span>
              <span className={cx('name')}>{resultData?.name}님</span>
            </div>
            <div className={cx('textArea')}>
              “개발 구현 능력 검사를 통해
              <br />
              나의 개발능력을 진단해보세요.”
            </div>
          </a>
        </Link>
      );

    // [D] 개역검X && 개능검O
    if (!paccResult && pstResult)
      return (
        <Link href={RouteUrl.PHS_PACC_TEST_GATE} legacyBehavior>
          <a className={cx('userInfoInner')} target={'_blank'} role="button">
            <div className={cx('userInfoWrap')}>
              {/* [D] 유저 이미지 없는 경우 'default' 클래스 추가 */}
              <div
                className={cx('profileImage', { default: !isProfileImage })}
                style={isProfileImage ? { backgroundImage: `url(${resultData?.profileImageUrl})` } : {}}
              >
                {/* [D] 유저 이미지 없는 경우 default 이미지 추가 */}
                {!isProfileImage && <Icon name="profileDefault" width={72} height={72} />}
                {/* [D] 개능검 미응시인 경우 'default' 클래스 추가 */}
                {/* [D] grade 값으로 아이콘 분기 처리 */}
                {grade && (
                  <div className={cx('gradeArea', { default: !pstResult }, grade)}>
                    <div className={cx('tooltipArea')}>
                      <div className={cx('tooltip')}>최고등급 : {gradeTextSelectMap[grade]}</div>
                      <Icon name="tooltipBottomTail" width={8} height={8} fill={Colors.C_COOL_GRAY_70} />
                    </div>
                  </div>
                )}
              </div>
              {/* [D] 개역검 미응시인 경우 'default' 클래스 추가 및 '나의 역량 유형은?' 텍스트 변경 */}
              <span className={cx('badge', { default: !paccResult })}>{badgeText}</span>
              <span className={cx('name')}>{resultData?.name}님</span>
            </div>
            <div className={cx('textArea')}>
              “개발자 역검을 통해
              <br />
              나의 역량유형을 확인해보세요.”
            </div>
          </a>
        </Link>
      );
  };

  return <>{userInfoComponent(paccResult, pstResult)}</>;
};

export default UserInfo;
